// extracted by mini-css-extract-plugin
export default {"contactbox":"Contact_contactbox__TC+YD"};